import { fromJS } from 'immutable';

import * as ActionTypes from '../constants/ActionTypes';

const initialState = fromJS({
  experts: {},
});

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCHED_TOPIC:
      return state.mergeIn(
        ['experts'],
        fromJS(action.payload.entities.experts),
      );

    default:
      return state;
  }
};
